import { fields } from 'modules';

import * as dataService from './dataService';



interface IProps {
  label?: string;
}

export const InvestmentAreaSelectField = (props?: IProps) => {
  return fields.genEnumSelectFieldComponent(dataService.useInvestmentAreaSelectField, {
    label: props?.label
  });
};

export const InvestmentAreaMultiSelectField = (props?: IProps) => {
  return fields.genEnumMultiSelectFieldComponent(dataService.useInvestmentAreaSelectField, {
    label: props?.label
  });
};
